<template>
  <div>
    <DeleteModal
      :is-delete-modal-active.sync="isDeleteModalActive"
      :items="deleteItem"
      @confirm-delete="confirmDelete($event)" />
    <SkillNameAdd
      ref="skillNameAdd"
      :is-sidebar-active.sync="isSidebarActive"
      @add-skill-name="addSkillName" />
    <SkillNameDetail
      :is-sidebar-active.sync="isSidebarDetailActive"
      :initial-skill-name="initialSkillName"
      :selected-item.sync="selectedItem"
      @update-skill-name="updateSkillName($event)"
      @delete-item="openDeleteModal($event)" />
    <SkillNameFilter
      :search-skill-name.sync="filter.searchSkillName"
      :search-dnis.sync="filter.searchDnis"
      :status-filter.sync="filter.status"
      @fetch-filter="fetchFilter()" />
    <b-card class="mt-2">
      <TableTop
        v-model="pagination.limit"
        label="Add Skill Name"
        @active-sidebar="activeSidebar()"
        @change="fetchFilter()" />
      <b-table
        :items="items"
        :fields="fields"
        striped
        hover
        responsive
        @sort-changed="sortFilter($event)"
        @row-clicked="rowClick($event)">
        <template #cell(status)="data">
          <b-badge :variant="$statusValue(data.value)">
            {{ data.value | formatStatusData }}
          </b-badge>
        </template>
      </b-table>
      <b-row>
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center justify-content-sm-end">
          <b-pagination
            v-model="pagination.page"
            :total-rows="pagination.totalDocs"
            :per-page="pagination.limit"
            first-number
            last-number
            class="mb-1 mt-2 mr-1"
            prev-class="prev-item"
            next-class="next-item"
            @change="showCurrentPage($event)">
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18" />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import SkillNameProvider from '@/resources/SkillNameProvider'
import DeleteModal from '@/components/DeleteModal.vue'
import TableTop from '@/components/TableTop.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SkillNameFilter from '@/components/SkillName/SkillNameFilter.vue'
import SkillNameDetail from '@/components/SkillName/SkillNameDetail.vue'
import SkillNameAdd from '@/components/SkillName/SkillNameAdd.vue'

const SkillNameService = new SkillNameProvider()

export default {
  components: {
    SkillNameAdd,
    SkillNameDetail,
    SkillNameFilter,
    DeleteModal,
    TableTop
  },
  data () {
    return {
      isSidebarActive: false,
      isSidebarDetailActive: false,
      isDeleteModalActive: false,
      filter: {
        searchSkillName: '',
        searchDnis: '',
        status: ''
      },
      pagination: {
        page: 1,
        limit: 10,
        totalDocs: 10
      },
      fields: [
        { key: 'skillName', label: 'Skill Name', sortable: true },
        { key: 'dnis', label: 'Dnis' },
        { key: 'status', label: 'Status' }
      ],
      items: [],
      initialSkillName: {},
      selectedItem: {},
      deleteItem: {}
    }
  },
  mounted () {
    this.getSkillName()
  },
  methods: {
    async getSkillName () {
      try {
        const filters = { ...this.filter }
        filters.searchDnis = this.$replacePhoneNumber(filters?.searchDnis, '+66')
        const data = await SkillNameService.paginate(this.pagination.page, this.pagination.limit, filters)
        this.setPagination(data.page, data.totalDocs)
        this.items = [...data.data]
      } catch (err) {
        console.error(err)
      }
    },
    async addSkillName (val) {
      try {
        const payload = val
        payload.dnis = this.$replacePhoneNumber(payload?.dnis, '+66')
        await SkillNameService.create(payload)
        await this.getSkillName()
        this.resetFormAndToggleSideBar(this.$refs.skillNameAdd)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Add Record Successfully',
            icon: 'EditIcon',
            variant: 'success',
            text: '👋 Skill Name has been added'
          }
        })
      } catch (err) {
        if (err && err?.statusCode === 409) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Failed: Data is duplicated',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'code or name is duplicated'
            }
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error: System Error',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Please try again later.'
            }
          })
        }
      }
    },
    async updateSkillName (val) {
      try {
        const payload = { ...val }
        delete payload.id
        payload.dnis = this.$replacePhoneNumber(payload?.dnis, '+66')
        const { data } = await SkillNameService.update(val.id, payload)
        await this.getSkillName()
        this.setDataInitialAndSelectItem(data)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Updated Successfully',
            icon: 'EditIcon',
            variant: 'success',
            text: '👋 Skill Name has been updated'
          }
        })
      } catch (err) {
        if (err && err?.statusCode === 409) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Failed: Data is duplicated',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'code or name is duplicated'
            }
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error: System Error',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Please try again later.'
            }
          })
        }
      }
    },
    async confirmDelete (val) {
      try {
        this.isSidebarDetailActive = false
        await SkillNameService.remove(val.ID)
        await this.getSkillName()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Deleted Successfully',
            icon: 'EditIcon',
            variant: 'success',
            text: '👋 Skill Name Type has been deleted'
          }
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Deleted Fail',
            icon: 'EditIcon',
            variant: 'danger',
            text: `😞 Skill Name has been Failed ${error}`
          }
        })
      }
    },
    activeSidebar () {
      this.isSidebarActive = true
    },
    rowClick (val) {
      this.setDataInitialAndSelectItem(val)
      this.isSidebarDetailActive = true
    },
    openDeleteModal (val) {
      this.deleteItem = { ...val }
      this.isDeleteModalActive = true
    },
    setDataInitialAndSelectItem (val) {
      this.selectedItem = { ...val }
      this.initialSkillName = { ...val }
    },
    resetFormAndToggleSideBar (ref) {
      this.isSidebarActive = !this.isSidebarActive
      if (ref && ref.resetForm()) ref.resetForm()
    },
    fetchFilter () {
      this.setPagination(1)
      this.getSkillName()
    },
    showCurrentPage (page) {
      this.setPagination(page)
      this.getSkillName()
    },
    setPagination (page, totalDocs) {
      this.pagination.page = page || this.pagination.page
      this.pagination.totalDocs = totalDocs === 0 ? 0 : totalDocs || this.pagination.totalDocs
    }
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 0;
}
</style>
